"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPriorAuthorizationCommsPreview } from "@/src/actions/prior-authorization-comms";
import { getPriorAuthorizationComms } from "@/src/requests/prior-authorization";
export const PRIOR_AUTHORIZATION_COMMS_CACHE_KEY = "prior-authorization-comms";
export function usePriorAuthorizationComms(authDisplayId) {
  const $ = _c(14);
  let t0;
  let t1;
  if ($[0] !== authDisplayId) {
    t0 = [PRIOR_AUTHORIZATION_COMMS_CACHE_KEY, authDisplayId];
    t1 = () => getPriorAuthorizationComms(authDisplayId);
    $[0] = authDisplayId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!authDisplayId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      retry: false
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(t3);
  let t4;
  if ($[7] !== query.data) {
    t4 = query.data ?? [];
    $[7] = query.data;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== query.isError || $[10] !== query.isLoading || $[11] !== query.refetch || $[12] !== t4) {
    t5 = {
      comms: t4,
      isLoading: query.isLoading,
      isError: query.isError,
      refetch: query.refetch
    };
    $[9] = query.isError;
    $[10] = query.isLoading;
    $[11] = query.refetch;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export function usePriorAuthorizationCommsPreview(authDisplayId, sentAt) {
  const $ = _c(8);
  let t0;
  let t1;
  if ($[0] !== authDisplayId || $[1] !== sentAt) {
    t0 = [PRIOR_AUTHORIZATION_COMMS_CACHE_KEY, authDisplayId, "preview", sentAt];
    t1 = () => getPriorAuthorizationCommsPreview({
      authDisplayId,
      sentAt
    });
    $[0] = authDisplayId;
    $[1] = sentAt;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  const t2 = !!(authDisplayId && sentAt);
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      retry: false
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
}
export function invalidatePriorAuthorizationCommsCache(queryClient: ReturnType<typeof useQueryClient>, authDisplayId: string) {
  return queryClient.invalidateQueries({
    queryKey: [PRIOR_AUTHORIZATION_COMMS_CACHE_KEY, authDisplayId]
  });
}